<div class="slider" [class.disabled]="isDisabled">
    <div class="bar" [style.width]="sliderWidth + 'px'" (mousemove)="handlerSliding($event)"
        (panmove)="handlerSliding($event)">
        <span class="left-handle" [ngClass]="{'active': isHandlerActive && currentHandlerIndex === handlerIndex.left,
                      'last-active': currentHandlerIndex === handlerIndex.left
                    }" [style.left.%]="handlerX[handlerIndex.left]"
            (mousedown)="setHandlerActive($event, handlerIndex.left)"
            (panstart)="setHandlerActive($event, handlerIndex.left)">
            <span *ngIf="!hideTooltip" class="handle-tooltip">{{currentValues[handlerIndex.left]}}</span>
        </span>
        <div class="filler">
            <span *ngIf="multiRange" [style.left.%]="handlerX[0]"
                [style.width.%]="handlerX[handlerIndex.right] - handlerX[handlerIndex.left]"></span>
            <span *ngIf="!multiRange" [style.left.%]="0" [style.width.%]="handlerX[0]"></span>
        </div>
        <span *ngIf="multiRange" class="right-handle" [ngClass]="{'active': isHandlerActive && currentHandlerIndex === handlerIndex.right,
                      'last-active': currentHandlerIndex === handlerIndex.right
                    }" [style.left.%]="handlerX[handlerIndex.right]"
            (mousedown)="setHandlerActive($event, handlerIndex.right)"
            (panstart)="setHandlerActive($event, handlerIndex.right)">
            <span *ngIf="!hideTooltip" class="handle-tooltip">{{currentValues[handlerIndex.right]}}</span>
        </span>
    </div>
    <div class="filler" *ngIf="showStepIndicator">
        <div class="step-indicators">
            <span *ngFor="let stepPos of stepIndicatorPositions; let i = index" [style.left.px]="stepPos">
                <br>
                <div class="step-label">
                    {{stepIndicatorLabel[i]}}
                </div>
            </span>
        </div>
    </div>
    <div class="values" *ngIf="!hideValues && !showStepIndicator">
        <span class="left-value">{{initValues[handlerIndex.left]}}</span>
        <span class="right-value">{{initValues[handlerIndex.right]}}</span>
    </div>
</div>